// bundle-dropdown-handler.js

function initBundleDropdown() {
  const dropdowns = document.querySelectorAll('.bundle-dropdown');

  dropdowns.forEach(dropdown => {
    const toggle = dropdown.querySelector('.bundle-dropdown__toggle');
    if (!toggle) return;

    let isCollapsed = dropdown.classList.contains('collapsed');

    const updateHeight = () => {
      dropdown.style.height = dropdown.scrollHeight + 'px';
    };

    const collapseDropdown = () => {
      dropdown.style.height = '60px';
      dropdown.classList.add('collapsed');
      isCollapsed = true;
    };

    const expandDropdown = () => {
      dropdown.classList.remove('collapsed');
      updateHeight();
      isCollapsed = false;
    };

    // Initial height setup
    if (isCollapsed) {
      dropdown.style.height = '60px';
    } else {
      updateHeight();
    }

    // Undgå dobbelt-binding
    toggle.onclick = () => {
      if (isCollapsed) {
        expandDropdown();
      } else {
        collapseDropdown();
      }
    };

    // Resize justering
    window.addEventListener('resize', () => {
      if (!isCollapsed) {
        updateHeight();
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initBundleDropdown();
});